// Must stay the first import: it takes a set-password link's token out of the
// address before any other module runs, so nothing that reads the address —
// Sentry, a tracker — ever finds it there.
import "./core/password_link_token_guard";
import "mapbox-gl/dist/mapbox-gl.css";
import "./index.css";

import React from "react";
import ReactDOM from "react-dom";

import App from "./app";
import { installCssPreloadRecovery } from "./core/css_preload_recovery";

// Before the first render, so it is listening by the time a route's lazy chunk
// pulls in its stylesheets.
installCssPreloadRecovery();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
